module.exports = __webpack_public_path__ + "bdb59c00f931324a82e55045f41a0772.png";